<template>
  <RestaurantCategoriesList/>
</template>
<script>
import RestaurantCategoriesList from '@/components/modules/restaurant/categories/list'
export default {
  name: 'Restaurantcategories',
  components: {
    RestaurantCategoriesList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/restaurant/categories/list.vue